import styled from '@emotion/styled'

const CheckoutSectionFootnote = styled.div`
  label: CheckoutCustomerSignOut;
  margin: 1.5rem 0 0;

  p {
    font-size: ${(props) => props.theme.fonts.sizes.small};
  }
`

export default CheckoutSectionFootnote
